<script lang="ts" setup>
import { NxtSideModal } from '@future-harry/nxt-styles';
import { useLanguagesStore } from '@/core/collections/languages/languages.store';
import { useI18n } from 'vue-i18n';
import { useUserInfoStore } from '@/core/collections/user-info/user-info.store';
import { storeToRefs } from 'pinia';
import VerticalTabs from '@/core/components/layout-elements/VerticalTabs.vue';
import { SettingsTab } from '@/apps/admin/components/settings/constants';
import GeneralTab from './tabs/GeneralTab.vue';
import { Language } from '@future-harry/nxt-vue-library';

const languagesStore = useLanguagesStore();
const { allLanguagesOptionsFormat } = storeToRefs(languagesStore);

const userInfoStore = useUserInfoStore();
const { userInfo } = storeToRefs(userInfoStore);

const { t } = useI18n();

const emits = defineEmits(['onCloseSettings']);

function changeLanguage(language: Language) {
   if (!userInfo.value) return;
   userInfoStore.changeUserInfoLanguage(language);
}

const activeTab = ref('general');
const tabs: SettingsTab[] = [
   {
      id: 'general',
      i18n_key: 'job-board.settings.general',
   },
];
</script>

<template>
   <NxtSideModal :title="t('settings.setting')" :width="'92.3rem'" @on-close="emits('onCloseSettings')">
      <VerticalTabs v-model="activeTab" :tabs="tabs">
         <GeneralTab :user-info="userInfo" :languages-options="allLanguagesOptionsFormat" @change-language="changeLanguage" />
      </VerticalTabs>
   </NxtSideModal>
</template>
